module.exports = __webpack_public_path__ + "img/SSP.e96b9781.svg";